import { decomposeColor } from '@mui/material/styles';
import { hslToRgb } from '@mui/material/styles';
import { rgbToHex } from '@mui/material/styles';

// Matiz (0–360) de uma cor. O MUI converte HSL → RGB, mas não o contrário.
// Cor sem matiz (cinza) devolve 0.
export function hue(color) {
  const [r, g, b] = decomposeColor(color).values.map((value) => value / 255);
  const max = Math.max(r, g, b);
  const delta = max - Math.min(r, g, b);
  if (delta === 0) return 0;

  let sector;
  if (max === r) sector = ((g - b) / delta) % 6;
  else if (max === g) sector = (b - r) / delta + 2;
  else sector = (r - g) / delta + 4;

  return (sector * 60 + 360) % 360;
}

// A cor com saturação e luminosidade fixas, opaca, e o matiz opcionalmente
// girado (`hueShift`, em graus). Gera tons que a transparência não consegue (ela
// clareia, mas não satura: uma cor pouco saturada vira cinza) e, com S e L
// fixos, o contraste do texto não depende da cor da marca.
export function withSaturationLightness(color, saturation, lightness, hueShift = 0) {
  const shiftedHue = (hue(color) + hueShift + 360) % 360;
  return rgbToHex(hslToRgb(`hsl(${shiftedHue}, ${saturation}%, ${lightness}%)`));
}

// Tom suave de uma cor: pastel claro no light, tom profundo no dark. Texto em
// cima: o contrastText que o augmentColor calcula (escuro no light, claro no
// dark). Ponto de partida: a receita do design (matiz mantido, light S 78% / L
// 91%, dark S 42% / L 24%). O light foi ajustado pela referência do WhatsApp
// (#874), que gira o matiz em vez de mantê-lo (verde #1DAA61, 149°, → balão
// #D9FDD3, 111°, S 91% / L 91%): mantendo o matiz, o roxo da Beworks vira
// lavanda; girado, um azul claro que combina com o fundo. O dark segue a receita
// do design (o giro levava o azul padrão do MUI para verde-água).
const SOFT_TONE = {
  light: { saturation: 91, lightness: 91, hueShift: -38 },
  dark: { saturation: 42, lightness: 24, hueShift: 0 },
};

export function softTone(color, scheme) {
  const { saturation, lightness, hueShift } = SOFT_TONE[scheme];
  return withSaturationLightness(color, saturation, lightness, hueShift);
}
